import {
  SET_ADMIN_LIST,
  FETCH_ALL,
  CREATE,
  UPDATE
} from './types.js'

export default {
  /**
   * Fetch all enteries from admin table
   */
  async [FETCH_ALL] ({ commit }) {
    try {
      const response = await this._vm.$network_utils.getAdmins()
      commit(SET_ADMIN_LIST, response)
      localStorage.setItem('admin_list', JSON.stringify(response))
    } catch (e) {
      console.error(e)
    }
  },

  /**
   * Fetch admins list from local storage
   */
  getLocalStorage ({ commit }) {
    const data = JSON.parse(localStorage.getItem('admin_list'))
    commit(SET_ADMIN_LIST, data)
  },

  /**
   * Create new admin in database and append it to admin_list
   */
  async [CREATE] ({ dispatch, state }, { data, refresh }) {
    try {
      const r = await this._vm.$network_utils.postAdmin(state.staged_admin)
      if (refresh) {
        dispatch(FETCH_ALL)
      }
      this._vm.$utils.emit('show_toast', {
        text: `Success: You successfully created the following admin: ${r.full_name}`
      })
    } catch (e) {
      this._vm.$utils.emit('show_toast', { text: `Error: try again` })
      console.error(e)
    }
  },

  /**
   * Update admin data in database and append it to admin_list
   */
  async [UPDATE] ({ dispatch, state }, refresh) {
    try {
      const r = await this._vm.$network_utils.updateAdmin(state.staged_admin)
      if (refresh) {
        dispatch(FETCH_ALL)
      }
      this._vm.$utils.emit('show_toast', {
        text: `Success: You successfully updated the following admin: ${r.full_name}`
      })
    } catch (e) {
      this._vm.$utils.emit('show_toast', { text: `Error: try again` })
      console.error(e)
    }
  }
}
